import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import NumberFormat from "react-number-format";
import { useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";
import Calculator from "../imgs/Calculator.svg";
// import { countCalc } from "../counter.service";
import { url } from "../api.url";
import { useTranslation } from "react-i18next";
import axios from "axios";
// import AdsComponent from "../components/AdsComponent";
// import ReCAPTCHA from "react-google-recaptcha";

import { Tooltip } from "react-tippy";

const styles = {
  title: "text-left lg:self-center lg:w-max 4xl:text-xl flex max-w-[215px]",
  title2: "text-left lg:self-center lg:w-max text-sm flex max-w-[215px]",
  input: "p-3 max-w-xs rounded-lg 4xl:text-xl mb-2 lg:mb-0",
};

export default function Form() {
  //Data passed by props, enabling edition from results
  const { state } = useLocation();

  const [t, i18n] = useTranslation("global");

  console.log(i18n.language);

  const navigate = useNavigate();

  //Display Data
  const [formValues, setFormValues] = useState(state);

  /*** State flags for data deletion buttons ***/
  const [clearSueldo, setClearSueldo] = useState("hidden");
  const [clearDependientes, setClearDependientes] = useState("hidden");
  const [clearIngresosCotizables, setClearIngresosCotizables] =
    useState("hidden");
  const [clearIngresosNoCotizables, setClearIngresosNoCotizables] =
    useState("hidden");
  const [showError, setShowError] = useState("hidden");
  const [postCount, setPostCount] = useState(false);
  const [results, setResults] = useState({});

  //Error handling state array
  const [errors, setErrors] = useState({});

  //Pre-format data array, holds results.
  const [dataArray, setDataArray] = useState(state);

  const [ipAddress, setIPAddress] = useState("");

  const MAX_DEPENDIENTES = 10;
  const MAX_SALARIO = 999999999;
  const MAX_SALARIO_MASKED = "$999,999,999";
  const TSS_TARIFA_DEPENDIENTES_ADICIONALES = 1587.38;
  // const withValueLimit = ({ floatValue }) => floatValue <= MAX_DEPENDIENTES;
  // const salarioLimit = ({floatValue}) => floatValue < MAX_SALARIO ;

  // const recaptchaRef = useRef();

  useEffect(() => {
    const fetchIPAddress = async () => {
      try {
        const response = await axios.get("https://api.ipify.org/?format=json");
        const { ip } = response.data;
        setIPAddress(ip);
      } catch (error) {
        console.error("Error fetching IP address:", error);
      }
    };

    fetchIPAddress();
  }, []);

  useEffect(() => {
    let countEndpoint = url + "calc_count";
    console.log(ipAddress);
    if (postCount) {
      const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          fechaCalculo: new Date().toString(),
          ip: ipAddress,
        }),
      };
      //   console.log("EXAM ANSWERS POST:",requestOptions)
      fetch(countEndpoint, requestOptions)
        .then((response) => response.json())
        .then((data) => {
          data;
        });
    }
  }, [postCount]);

  useEffect(() => {
    if (results.sueldo)
      navigate("/calculadora-de-salarios/resultados", { state: results });
  }, [results]);

  const handleSubmit = async () => {
    //Checking that sueldo isn't empty.

    if (
      formValues?.sueldo < 1 ||
      !formValues.sueldo ||
      Number(formValues?.sueldo?.replaceAll(",", "").replace("$", "")) < 1
    ) {
      setErrors({ ...errors, ["sueldo"]: t("form.error1") });
      setShowError("flex");
    } else if (
      formValues?.dependientes &&
      formValues?.dependientes * TSS_TARIFA_DEPENDIENTES_ADICIONALES >
        Number(formValues?.sueldo?.replaceAll(",", "").replace("$", ""))
    ) {
      setErrors({ ...errors, ["sueldo"]: t("form.error2") });
      setShowError("flex");
    } else {
      // const captchaToken = await recaptchaRef.current.executeAsync();

      setPostCount(true);

      let result = dataArray;
      if (!result.sueldo) {
        result = formValues;
      }
      if (!result.dependientes) {
        result.dependientes = 0;
      }
      if (!result.ingresosCotizables) {
        result.ingresosCotizables = 0;
      }
      if (!result.ingresosNoCotizables) {
        result.ingresosNoCotizables = 0;
      }
      setResults(result);
      //  navigate('/calculadora-de-salarios/resultados',{state:result})
    }
  };

  return (
    <div>
      <Navbar />
      <div className="font-dmSans w-full">
        {/* Title Container */}
        <div className="flex justify-center">
          <h1 className="font-bold text-2xl 2xl:text-3xl 5xl:text-4xl 4xl:leading-[40px] leading-[30px]">
            {t("form.page-title")}
          </h1>
        </div>
        {/* Title Underline */}
        <img
          src={require("../imgs/Title-Line.png")}
          alt=""
          className="float-right lg:w-[55%] xl:w-[50%] 4xl:pr-[35rem] 4xl:mr-[5rem] pr-[20rem] mr-[5rem] sm:w-[20%]"
        />

        {/* Form Box */}
        <div className="block w-full">{/* <AdsComponent /> */}</div>
        <div className="flex w-full lg:pb-4">
          <div className="bg-[#F2F7F7] rounded-[12px] drop-shadow-lg p-4 max-w-fit mx-auto lg:p-8 font-montserrat lg:w-[50%] mt-10 sm:block">
            {/* Form Title */}
            <h1 className="font-bold text-[24px] text-[#03045E] text-left">
              {t("form.form-title")}
            </h1>
            {/* Form Subtitle */}
            <h2 className="font-bold text-[18px] text-[#046865] text-left mt-5">
              {t("form.form-subtitle")}
            </h2>
            <form className="lg:grid lg:grid-cols-3 lg:gap-4 lg:gap-x-52 text-[#046865] mt-10 sm:block pl-[5%]">
              {/* SUELDO INPUT ROW*/}
              <div className={styles.title}>1. {t("form.monthly-salary")}</div>
              <div>
                <NumberFormat
                  name="sueldo"
                  value={formValues?.sueldo}
                  onValueChange={(e) => {
                    const { formattedValue, value } = e;
                    if (Number(value) || value != state.sueldo) {
                      let formattedValueTemp = formattedValue;
                      let valueTemp = value;

                      if (Number(value) >= MAX_SALARIO) {
                        formattedValueTemp = MAX_SALARIO_MASKED;
                        valueTemp = MAX_SALARIO;
                      }

                      setFormValues({
                        ...formValues,
                        ["sueldo"]: formattedValueTemp,
                      });
                      setClearSueldo("flex");
                      // setCleanData('flex')
                      setDataArray({ ...dataArray, ["sueldo"]: valueTemp });
                      setErrors({});
                      setShowError("hidden");
                    }
                  }}
                  className={styles.input}
                  thousandSeparator={true}
                  prefix="$"
                  allowLeadingZeros={false}
                  displayType="input"
                  decimalScale={2}
                  allowNegative={false}
                />
              </div>
              <div className="ml-0 mt-3 lg:mt-0 grid content-center">
                <div
                  className={`${clearSueldo} hover:cursor-pointer place-self-center`}
                  onClick={() => {
                    setFormValues({ ...formValues, ["sueldo"]: 0 });
                    setDataArray({ ...dataArray, ["sueldo"]: 0 });
                    setClearSueldo("hidden");
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#ff0000"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <circle cx="12" cy="12" r="10"></circle>
                    <line x1="15" y1="9" x2="9" y2="15"></line>
                    <line x1="9" y1="9" x2="15" y2="15"></line>
                  </svg>
                </div>
              </div>
              {/* DEPENDIENTES ADICIONALES INPUT ROW*/}
              <div className={styles.title2}>
                2. {t("form.additional-dependents")}
              </div>
              <div className="2xl:pr-10">
                <NumberFormat
                  name="dependientes"
                  value={formValues?.dependientes}
                  onValueChange={(e) => {
                    const { formattedValue, value } = e;
                    if (Number(value) || value != state.dependientes) {
                      let valueTemp = value;
                      let formattedValueTemp = formattedValue;
                      if (Number(value) > MAX_DEPENDIENTES) {
                        valueTemp = 10;
                        formattedValueTemp = "10";
                      }

                      setFormValues({
                        ...formValues,
                        ["dependientes"]: formattedValueTemp,
                      });
                      setClearDependientes("flex");
                      // setCleanData('flex')
                      setDataArray({
                        ...dataArray,
                        ["dependientes"]: valueTemp,
                      });
                    }
                  }}
                  allowLeadingZeros={false}
                  allowNegative={false}
                  displayType="input"
                  className={
                    "p-3 w-[70px] rounded-lg 4xl:text-xl mb-2 mr-36 lg:mr-8 xl:mr-24 2xl:mr-36 lg:mb-0"
                  }
                />
              </div>
              <div className="ml-0 mt-3 lg:mt-0 grid content-center">
                <div
                  className={`${clearDependientes} hover:cursor-pointer place-self-center`}
                  onClick={() => {
                    setFormValues({ ...formValues, ["dependientes"]: 0 });
                    setDataArray({ ...dataArray, ["dependientes"]: 0 });
                    setClearDependientes("hidden");
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#ff0000"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <circle cx="12" cy="12" r="10"></circle>
                    <line x1="15" y1="9" x2="9" y2="15"></line>
                    <line x1="9" y1="9" x2="15" y2="15"></line>
                  </svg>
                </div>
              </div>
              {/* ING. COTIZABLES TSS INPUT ROW*/}
              <div className={styles.title2}>
                3. {t("form.tss-income")}{" "}
                <Tooltip
                  title={t("form.tss-tooltip")}
                  position="top"
                  animation="perspective"
                  className="w-[50px] mr-[2.5rem]"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#793DDC"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <circle cx="12" cy="12" r="10"></circle>
                    <line x1="12" y1="16" x2="12" y2="12"></line>
                    <line x1="12" y1="8" x2="12.01" y2="8"></line>
                  </svg>
                </Tooltip>
              </div>
              <div>
                <NumberFormat
                  type="text"
                  name="ingresosCotizables"
                  value={formValues?.ingresosCotizables}
                  onValueChange={(e) => {
                    const { formattedValue, value } = e;
                    if (Number(value) || value != state.ingresosCotizables) {
                      setFormValues({
                        ...formValues,
                        ["ingresosCotizables"]: formattedValue,
                      });
                      setClearIngresosCotizables("flex");
                      // setCleanData('flex')
                      setDataArray({
                        ...dataArray,
                        ["ingresosCotizables"]: value,
                      });
                    }
                  }}
                  className={styles.input}
                  thousandSeparator={true}
                  prefix="$"
                  allowLeadingZeros={false}
                  allowNegative={false}
                  displayType="input"
                  decimalScale={2}
                />
              </div>
              <div className="ml-0 mt-3 lg:mt-0 grid content-center">
                <div
                  className={`${clearIngresosCotizables} hover:cursor-pointer place-self-center`}
                  onClick={() => {
                    setFormValues({ ...formValues, ["ingresosCotizables"]: 0 });
                    setDataArray({ ...dataArray, ["ingresosCotizables"]: 0 });
                    setClearIngresosCotizables("hidden");
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#ff0000"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <circle cx="12" cy="12" r="10"></circle>
                    <line x1="15" y1="9" x2="9" y2="15"></line>
                    <line x1="9" y1="9" x2="15" y2="15"></line>
                  </svg>
                </div>
              </div>
              {/* ING. NO COTIZABLES TSS INPUT ROW*/}
              <div className={styles.title2}>
                4. {t("form.no-tss-income")}
                <Tooltip
                  title={t("form.no-tss-tooltip")}
                  position="top"
                  animation="perspective"
                  className="w-[50px] mr-[0.8rem]"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#793DDC"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <circle cx="12" cy="12" r="10"></circle>
                    <line x1="12" y1="16" x2="12" y2="12"></line>
                    <line x1="12" y1="8" x2="12.01" y2="8"></line>
                  </svg>
                </Tooltip>
              </div>
              <div>
                <NumberFormat
                  type="text"
                  name="ingresosNoCotizables"
                  value={formValues?.ingresosNoCotizables}
                  onValueChange={(e) => {
                    const { formattedValue, value } = e;
                    if (Number(value) || value != state.ingresosNoCotizables) {
                      setFormValues({
                        ...formValues,
                        ["ingresosNoCotizables"]: formattedValue,
                      });
                      setClearIngresosNoCotizables("flex");
                      // setCleanData('flex')
                      setDataArray({
                        ...dataArray,
                        ["ingresosNoCotizables"]: value,
                      });
                    }
                  }}
                  className={styles.input}
                  thousandSeparator={true}
                  prefix="$"
                  allowLeadingZeros={false}
                  allowNegative={false}
                  displayType="input"
                  decimalScale={2}
                />
              </div>
              <div className="ml-0 mt-3 lg:mt-0 grid content-center">
                <div
                  className={`${clearIngresosNoCotizables} hover:cursor-pointer place-self-center`}
                  onClick={() => {
                    setFormValues({
                      ...formValues,
                      ["ingresosNoCotizables"]: 0,
                    });
                    setDataArray({ ...dataArray, ["ingresosNoCotizables"]: 0 });
                    setClearIngresosNoCotizables("hidden");
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#ff0000"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <circle cx="12" cy="12" r="10"></circle>
                    <line x1="15" y1="9" x2="9" y2="15"></line>
                    <line x1="9" y1="9" x2="15" y2="15"></line>
                  </svg>
                </div>
              </div>
            </form>

            {/* <div className={`${clean} justify-center`}>
      <button className={`mt-10 text-red-500 inline-flex hidden`} onClick={()=>{clearData()}}><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#ff0000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="15" y1="9" x2="9" y2="15"></line><line x1="9" y1="9" x2="15" y2="15"></line></svg> <p className="ml-2">Limpiar Todo</p> </button>
    </div> */}
            <div className={`flex justify-center mt-10 ${showError}`}>
              <p className="text-red-500 text-center">{errors.sueldo}</p>
            </div>

            {/* <ReCAPTCHA sitekey={captchaKey} ref={recaptchaRef} /> */}
          </div>
          <button
            className="mt-20 hidden h-fit self-center justify-center w-28 font-bold bg-[#FFBE21] text-white text-center p-4 rounded-xl hover:bg-[#FFB111] 4xl:text-xl hover:shadow-lg"
            onClick={() => {
              handleSubmit();
            }}
          >
            <div className="block">
              {t("form.submit-button")}
              <img src={Calculator} alt="" />
            </div>{" "}
          </button>
        </div>

        <div className="flex  justify-center mt-10 mb-10">
          <button
            className="font-bold bg-[#FFBE21] text-white text-center p-4 min-w-[280px] rounded-xl hover:bg-[#FFB111] 4xl:text-xl hover:shadow-lg"
            onClick={() => {
              handleSubmit();
            }}
          >
            {t("form.submit-button")}
          </button>
        </div>
      </div>
    </div>
  );
}
